const ITEMS = ["Estratégia", "Marketing", "Design", "Fotografia", "Vídeo", "Branding"];

export default function Marquee({ dark = false }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`px-8 font-display text-3xl font-medium italic md:text-5xl ${
              dark ? "text-white/85" : "text-royal/80"
            }`}
          >
            {item}
          </span>
          <span className={`h-2 w-2 rounded-full ${dark ? "bg-white/40" : "bg-royal/30"}`} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`overflow-hidden border-y py-8 md:py-10 ${
        dark ? "border-white/15 bg-royal" : "border-royal-line bg-white"
      }`}
      data-testid="marquee"
      aria-hidden
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
